import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "./motionPrimitives";

const FAQS = [
    {
        id: "faq-item-results-speed",
        q: "How fast will we see results?",
        a: "Paid campaigns typically generate qualified traffic within the first few weeks. SEO and AI systems compound over three to six months — we set clear 90-day milestones so you always know what to expect and when.",
    },
    {
        id: "faq-item-ai-integration",
        q: "What does AI integration actually involve?",
        a: "We audit your sales and service workflows, then deploy AI agents, chatbots and automations directly inside your CRM, inbox and website. The goal is simple: remove manual busywork so your team can focus on closing.",
    },
    {
        id: "faq-item-contracts",
        q: "Do you require long-term contracts?",
        a: "After an initial 90-day growth sprint, everything runs month-to-month. We keep clients with results, not paperwork.",
    },
    {
        id: "faq-item-company-size",
        q: "What size companies do you work with?",
        a: "From local Fort Lauderdale businesses to national mid-market brands. If growth matters to you, the playbook applies — scope and channel mix are the only things that change.",
    },
    {
        id: "faq-item-reporting",
        q: "How do you report on progress?",
        a: "A live dashboard plus a monthly strategy review covering spend, pipeline, rankings and revenue. We report on money metrics — never vanity metrics.",
    },
    {
        id: "faq-item-pricing",
        q: "How do we get started?",
        a: "Book a strategy call. We run a free audit of your marketing, search presence and AI opportunities, then send a 90-day roadmap with clear pricing before you commit to anything.",
    },
];

export default function Faq() {
    return (
        <section id="faq" data-testid="faq-section-container" className="bg-white py-20 lg:py-28">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    eyebrow="FAQ"
                    title="Frequently asked questions."
                    className="text-center"
                />

                <Reveal delay={0.1} className="mt-12">
                    <Accordion type="single" collapsible className="space-y-4">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.id}
                                value={`item-${i}`}
                                data-testid={f.id}
                                className="border border-[#E2E8F0] rounded-2xl px-6 bg-fog/60 hover:border-gold/50 transition-colors data-[state=open]:border-gold/70"
                            >
                                <AccordionTrigger className="py-5 font-display font-bold text-navy text-base sm:text-lg hover:no-underline hover:text-gold transition-colors">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-6 text-steel leading-relaxed">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
